
import { Injectable }       from '@angular/core';
import { AlunoSae } from './aluno-sae';
import { Observable }       from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';
import { HttpService } from 'ems-oauth2-client';
import { map, catchError , publishReplay, refCount} from 'rxjs/operators';

@Injectable()
export class AlunoSaeService extends ServiceUtil  {
    private url = '/academico/aluno';

    constructor(private http: HttpService, private pagerComponent: PagerComponent) { super(); }

    // recupera por id
    public getAlunoSae(id:number): Observable<AlunoSae> {
        return this.http.get(this.url + "/" +id)
                  .pipe(
                    map(this.extractObjectData),
                    catchError(this.handleError),
                    publishReplay(1),
                    refCount()
                );
    }

    filtrar(filtro : AlunoSae): Observable<AlunoSae[]>{
      let novaUrl = "{" ;
      let colocaVirgula = false;
      if(filtro.nome){
       novaUrl += "nome__contains:\"" + filtro.nome + "\"";
       colocaVirgula = true;
      }
      if(filtro.registroAcademico){
        if(colocaVirgula){
          novaUrl += ", ";
        }
       novaUrl += "\"registroAcademico\":\"" + filtro.registroAcademico + "\"";
      }
      novaUrl +=  "}";

      let urlModify = this.pagerComponent.formatarUrl(this.url,novaUrl,100,0);

      return this.http.get(urlModify)
            .pipe(map(response => {
                var result = response;
                return <AlunoSae[]> response;
            }),
            catchError(this.handleError),
            publishReplay(1),
            refCount()
          );
    }

    buscarAlunoPorRa(ra: string): Observable<AlunoSae>{
      let filtro: AlunoSae = new AlunoSae();
      filtro.registroAcademico = ra;
      return this.filtrar(filtro).pipe(map((results:AlunoSae[]) => {
        if(results && results.length > 0){
          return results[0];
        }else{
          return null;
        }
      }));
    }


    // extrai objeto da resposta http
    private extractObjectData(res: any) {
      return res as AlunoSae ;
    }



}
